export default "__VITE_ASSET__CTQtpKEw__"